var map = {
	"./chocolate-fictional/map_route.json": [
		6127,
		[
			6127
		]
	],
	"./chocolate/map_route.json": [
		8739,
		[
			8739
		]
	],
	"./hemas-clogard/map_route.json": [
		7056,
		[
			7056
		]
	],
	"./linqOne/map_route.json": [
		7424,
		[]
	],
	"./munchee-tikiri-marie/map_route.json": [
		7888,
		[
			7888
		]
	],
	"./shan-teas/map_route.json": [
		1093,
		[
			1093
		]
	],
	"./wipotech-chocolates/map_route.json": [
		3014,
		[
			3014
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9233;
module.exports = webpackAsyncContext;